import { QR_PROFILE_SOURCE } from '../constants/qrProfile';
import { routes } from '../routes/routes';

/** Parse a scanned WERULE profile URL into an in-app route path. */
export function parseWeruleProfileScan(text: string): string | null {
  const trimmed = text.trim();
  if (!trimmed) {
    return null;
  }

  let url: URL;
  try {
    url = trimmed.startsWith('http') ? new URL(trimmed) : new URL(trimmed, window.location.origin);
  } catch {
    return null;
  }

  if (url.origin !== window.location.origin) {
    return null;
  }

  const mentorMatch = url.pathname.match(/^\/mentor\/(\d+(?:-[^/]+)?)$/);
  if (mentorMatch) {
    const source = url.searchParams.get('source') || QR_PROFILE_SOURCE;
    return `${routes.MENTOR.replace(':id', mentorMatch[1])}?source=${encodeURIComponent(source)}`;
  }

  const menteeMatch = url.pathname.match(/^\/mentee\/(\d+(?:-[^/]+)?)$/);
  if (menteeMatch) {
    const source = url.searchParams.get('source') || QR_PROFILE_SOURCE;
    return `${routes.MENTEE.replace(':id', menteeMatch[1])}?source=${encodeURIComponent(source)}`;
  }

  return null;
}
